import { createConfirmation } from "react-confirm";
import PDFPreviewModal from "./PDFPreviewModal";

export const ShowPDFPreviewModal = createConfirmation(PDFPreviewModal);